import { CheckList } from '@/components/common/CheckList';
import { PageSection } from '@/components/common/PageSection';
import { SectionHeading } from '@/components/common/SectionHeading';
import { cn } from '@/lib/utils';
import { Roles } from '@/pages/About/data';

const SectionId = 'roles';
const TitleId = 'roles-title';

export function RolesSection() {
  return (
    <PageSection id={SectionId} titleId={TitleId}>
      <SectionHeading id={TitleId} title={Roles.title} description={Roles.description} />
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {Roles.groups.map((roleGroup) => (
          <div
            key={roleGroup.title}
            className={cn('rounded-lg border border-grid p-6 sm:p-8', roleGroup.highlighted ? 'bg-pad-light' : 'bg-paper')}
          >
            <h3 className="text-xl font-bold text-graphite">{roleGroup.title}</h3>
            <CheckList items={roleGroup.items} tone={roleGroup.highlighted ? 'redline' : 'steel'} className="mt-5" />
          </div>
        ))}
      </div>
    </PageSection>
  );
}